var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2"},[_c('b-button',{staticClass:"shadow",attrs:{"variant":"primary"},on:{"click":_vm.grabKurs}},[_c('font-awesome-icon',{attrs:{"icon":"cloud-download-alt"}}),_vm._v("\n            Tarik dari Situs BKF\n        ")],1)],1),_vm._v(" "),_c('paginated-browser',{ref:"kursBrowser",attrs:{"data-callback":_vm.getKurs},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var pagination = ref.pagination;
return [_c('table-kurs',{attrs:{"items":data},on:{"deleteKurs":_vm.handleDelete}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27343c4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrowseKurs.vue
// module id = null
// module chunks = 